<template>
	<div class="three-balls">
		<div class="ball ball1" />
		<div class="ball ball2" />
		<div class="ball ball3" />
	</div>
</template>

<script>
export default {
	 name: 'LoadingFullscreen'
}
</script>

<style lang="scss">
	.three-balls {
		margin: 0 auto;
		width: 170px;
		text-align: center;
		position: relative;

		.ball {
			position: relative;
			width: 20px;
			height: 20px;
			margin: 0 3px;
			border-radius: 50%;
			display: inline-block;
			animation: bouncedelay 2.5s infinite cubic-bezier(.62, .28, .23, .99) both;
		}

		.ball1 {
			animation-delay: -0.16s;
		}

		.ball2 {
			animation-delay: -0.08s;
		}
	}

	@keyframes bouncedelay {
		0% {
			bottom: 0;
			background-color: #03A9F4;
		}
		16.66% {
			bottom: 40px;
			background-color: #FB6542;
		}
		33.33% {
			bottom: 0px;
			background-color: #FB6542;
		}
		50% {
			bottom: 40px;
			background-color: #FFBB00;
		}
		66.66% {
			bottom: 0px;
			background-color: #FFBB00;
		}
		83.33% {
			bottom: 40px;
			background-color: #03A9F4;
		}
		100% {
			bottom: 0;
			background-color: #03A9F4;
		}
	}
</style>
